import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import ActionsMenu from "./actionMenu";
import Checkbox from "@mui/material/Checkbox";
import Switch from "@mui/material/Switch";
import dummyImage from "assets/images/userDummy.png";
import resolveAssetUrl from "utils/resolveAssetUrl";

export default function usersTableData({
  peopleList = [],
  onDelete,
  onToggleBlock,
  onAllowPermission,
  onToggleVerifiedBadge,
  onToggleTrustedSeller,
  key,
}) {
  const User = ({ image, name, contact }) => {
    const resolved = resolveAssetUrl(image);
    return (
      <MDBox display="flex" alignItems="center" lineHeight={1}>
        <MDAvatar
          src={resolved || dummyImage}
          alt={name}
          size="sm"
          imgProps={{
            referrerPolicy: "no-referrer",
            // Fall back to the placeholder if the stored URL 404s.
            onError: (event) => {
              if (event.target.src !== dummyImage) event.target.src = dummyImage;
            },
          }}
          sx={!resolved ? { border: "1px solid", borderColor: "grey.400" } : undefined}
        />
        <MDBox ml={2} lineHeight={1}>
          <MDTypography display="block" variant="button" fontWeight="medium">
            {name}
          </MDTypography>
          <MDTypography variant="caption">{contact}</MDTypography>
        </MDBox>
      </MDBox>
    );
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    return date;
  };

  return {
    columns: [
      {
        Header: "Verified",
        accessor: "select",
        width: "5%",
        align: "center",
      },
      { Header: "User", accessor: "user", width: "35%", align: "left" },
      { Header: "Role", accessor: "role", align: "left" },
      { Header: "Trusted Seller", accessor: "trustedSeller", align: "center" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Created At", accessor: "created", align: "center" },
      { Header: "Action", accessor: "action", align: "center" },
    ],

    rows: peopleList.map((person) => ({
      select: (
        <Checkbox
          checked={!!person?.verifiedBadge}
          onChange={() => onToggleVerifiedBadge?.(person?.id)}
        />
      ),
      user: (
        <User
          image={person?.profileImage || person?.profile_image || person?.avatar || person?.image}
          name={person?.fullName}
          contact={person?.phone || person?.email}
        />
      ),
      role: (
        <MDTypography
          component="span"
          variant="caption"
          color="text"
          fontWeight="medium"
          textTransform="capitalize"
        >
          {person?.role}
        </MDTypography>
      ),
      trustedSeller: (
        person?.role === "seller" ? (
          <Switch
            checked={!!person?.isVerifiedDealer}
            onChange={() => onToggleTrustedSeller?.(person?.id)}
            sx={{
              "& .MuiSwitch-switchBase.Mui-checked": {
                color: "#4CAF50 !important",
              },
              "& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
                borderColor: "#4CAF50 !important",
              },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                backgroundColor: "#4CAF50 !important",
                borderColor: "#4CAF50 !important",
              },
            }}
          />
        ) : (
          <MDTypography component="span" variant="caption" color="text">
            —
          </MDTypography>
        )
      ),
      status: (
        <MDBox ml={-1}>
          <MDBadge
            badgeContent={person?.isActive ? "Active" : "Blocked"}
            color={person.isActive ? "success" : "dark"}
            variant="gradient"
            size="sm"
          />
        </MDBox>
      ),
      created: (
        <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
          {formatDate(person?.createdAt)}
        </MDTypography>
      ),
      action: (
        <ActionsMenu
          status={person?.isActive}
          onDelete={() => onDelete(person?.id)}
          onToggleBlock={() => onToggleBlock(person?.id, person?.isActive)}
          onAllowPermission={() => onAllowPermission(person?.id, person?.hasUploadAccess)}
        />
      ),
    })),
  };
}
